<template>
	<div class="footermain">
		<div v-for="tab in tabs" :key="tab.path"
			class="f_div"
			:class="{selectf_div: isActive(tab)}"
			@click="toLinkUrl(tab.path)">
			<img :src="isActive(tab) ? tab.iconOn : tab.iconOff">
			<span>{{tab.text}}</span>
		</div>
	</div>
</template>

<script>
import { buildTabs, shouldNavigate } from '@/utils/tabbarMenu'

/**
 * 底部主菜单。
 *
 * 「工作台」只对内部人员出现，判定在 utils/tabbarMenu.js（可单测），
 * 与路由守卫、我的页入口共用同一条规则。
 *
 * 用户信息是异步拉的（App.vue mounted 里），所以内部人员刚进应用时可能先是 3 个 tab，
 * 拿到用户信息后变 4 个 —— 这个顺序是刻意的：宁可晚一点出现，也不能在没拿到结论前
 * 把内部入口显示给外部人员。
 */
export default {
	name: 'footermain',
	props: {
		active: {
			type: String,
			default: ''
		}
	},
	computed: {
		tabs() {
			const root = this.$root || {}
			return buildTabs(root.userInfo, root.isSuperRoot)
		}
	},
	methods: {
		isActive(tab) {
			return this.active === tab.path
		},
		toLinkUrl(url) {
			if (!shouldNavigate(this.$route ? this.$route.path : '', url)) return
			this.$router.push(url)
		}
	}
}
</script>

<style scoped>
	.footermain{
		width: 100%;
		height: calc(98px + env(safe-area-inset-bottom));
		padding-bottom: env(safe-area-inset-bottom);
		background: rgba(255, 255, 255, 0.94);
		display: flex;
		align-items: center;
		justify-content: flex-start;
		position: fixed;
		left: 0;
		bottom: 0;
		border-top: 1px solid #E8EDF2;
		box-shadow: 0 -8px 24px rgba(31, 41, 55, 0.08);
		backdrop-filter: blur(14px);
		-webkit-backdrop-filter: blur(14px);
		z-index: 100;
	}
	.f_div{
		flex: 1;
		min-height: 64px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		gap: 4px;
		font-size: 24px;
		color: #999999;
		line-height: 31px;
		font-weight: 500;
		-webkit-tap-highlight-color: transparent;
		transition: color 160ms ease, transform 160ms ease;
	}
	.f_div:active{
		transform: scale(0.94);
	}
	.f_div img{
		width: 40px;
		height: 40px;
		transition: transform 160ms ease;
	}
	.selectf_div{
		color: #4E89FF;
		font-weight: 700;
	}
	.selectf_div img{
		transform: translateY(-1px);
	}
</style>
